import HomeHero from "@/components/home/HomeHero";
import ScrollProgress from "@/components/home/ScrollProgress";
import { ProblemSection, EnemySection, MethodSection, BuildSection } from "@/components/home/HomeSections";
import TracksSection from "@/components/home/TracksSection";
import AssessmentWidget from "@/components/home/AssessmentWidget";
import CalculatorWidget from "@/components/home/CalculatorWidget";
import ObjectionWidget from "@/components/home/ObjectionWidget";
import BuiltForSection from "@/components/home/BuiltForSection";
import QualificationBlock from "@/components/home/QualificationBlock";
import DailyStandard from "@/components/home/DailyStandard";
import HomeFinal from "@/components/home/HomeFinal";

// "/" — rebuilt from 7figureclosingclub.com, restyled with the 7FCC
// blue/silver system. Section order and copy verbatim from the live page.
export default function HomePage() {
  return (
    <main className="overflow-x-clip bg-ink-950 font-sans text-fg">
      <ScrollProgress />
      <HomeHero />
      <ProblemSection />
      <EnemySection />
      <MethodSection />
      <BuildSection />
      <TracksSection />
      <AssessmentWidget />
      <CalculatorWidget />
      <ObjectionWidget />
      <BuiltForSection />
      <QualificationBlock />
      <DailyStandard />
      <HomeFinal />
    </main>
  );
}